import { useMutation } from '@tanstack/react-query';
import Api from '@/services/api';
import { BaseContext } from '@/types';

export type DownloadPDF = BaseContext & {
	id?: string;
	locale: string;
	sections?: string[];
};

async function downloadPDF(payload: DownloadPDF) {
	const url = 'ergonomic-tool/owas/document/pdf';
	const { data } = await Api.post<any>(url, payload);
	return data;
}

export const useDownloadPDF = () => {
	return useMutation((body: DownloadPDF) => downloadPDF(body));
};
